// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3VKSr","modalForm":"UpgradeEpcsModal_modalForm__3EiC1","modalFooter":"UpgradeEpcsModal_modalFooter__isEXo"};